import { TableCard } from '../../../../components'
import { MonitoramentoListHeader } from './components/header/MonitoramentoListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { MonitoramentoTable } from './table/MonitoramentoTable'

const MonitoramentoList = () => {
  return (
    <TableCard>
      <MonitoramentoListHeader />
      <MonitoramentoTable />
    </TableCard>
  )
}

export const MonitoramentoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <MonitoramentoList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
